import React, { useState, useEffect } from 'react';
import { PPTextField } from 'processor-plataform-ui';
import LcIconLink from '../../../Generic/LcIconLink';
import LcLoading from '../../../Generic/LcLoading';
import ProcessService from '../../../../services/ProcessService/ProcessService';
import SolicitationService from '../../../../services/SolicitationService/SolicitationService';
import SolicitationAttendantService from "../../../../services/SolicitationAttendantService/SolicitationAttendantService";
import AlertNotification, { AlertColor } from '../../../Dialog/AlertNotification';
import { MenuState } from '../../../../store/reducers/menuReducer';
import { PrefState } from '../../../../store/reducers/prefReducer';
import { RootState } from '../../../../store/index';
import { useSelector } from 'react-redux';
import './index.css';

interface Props {
    onVisibleModalVinculo: boolean;
    setOnVisibleModalVinculo: Function;
    selectedRadioRows: any[];
    setSelectedRadioRows: Function;
    rows: any[];
}

const InputLink: React.FC<Props> = (props) => {
    const pref = useSelector<RootState, PrefState>(state => state.pref);
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const solicitationService = new SolicitationService(props);
    const processService = new ProcessService(props);
    const solicitationAttendantService = new SolicitationAttendantService(props);
    const [loadingSaveVinculo, setLoadingSaveVinculo] = useState<boolean>(false);
    const [messageNotifications, setMessageNotification] = useState<string>("");
    const [onNotification, setOnNotification] = useState<boolean>(false);
    const [severityMessage, setSeverityMessage] = useState<AlertColor>("success");
    const [vinculoPai, setVinculoPai] = useState<string>('');

    const getById = async (id: number) => {
        try {
            return (await solicitationService.getById(id)).data;
        }
        catch (e) {
            return e
        }
    }

    const getProcessMajor = async (processId: number) => {
        try {
            var processResponse = await processService.GetById(processId);
            return (processResponse.data[0].processType === 9) ? true : false;
        }
        catch (error: any) {
            return false;
        }
    };

    const setNotification = (message: string, severity: AlertColor, timed: boolean) => {
        setMessageNotification(message);
        setSeverityMessage(severity);
        setOnNotification(true);

        if (timed) setTimeout(() => setOnNotification(false), 5000);
    }

    const saveVinculo = async (id: any, rows: any[], solicitations: any[]) => {
        setLoadingSaveVinculo(true);

        if (id !== "" && solicitations.length > 0) {
            let marjorTicket = rows.find(x => x.id === parseInt(id));

            if (marjorTicket === undefined || marjorTicket === null) {
                marjorTicket = await getById(parseInt(id));
            }

            let marjorProcess = await getProcessMajor(marjorTicket.idProcess);

            if (marjorProcess) {
                let alreadyLinkedTickets = await solicitationAttendantService.GetLinkedSolicitation(parseInt(id));

                let arrayTickettoLink = solicitations.map(data => {
                    return data.id;
                });

                if (alreadyLinkedTickets !== null && alreadyLinkedTickets.length > 0) {
                    var idAlreadyLinkedTickets = alreadyLinkedTickets.map(data => {
                        return data.id;
                    });

                    arrayTickettoLink = arrayTickettoLink.filter(v => !idAlreadyLinkedTickets.includes(v));

                    if (arrayTickettoLink && idAlreadyLinkedTickets.length > 0) {
                        var linkedTicketsFromRequesttoLink = arrayTickettoLink.filter(v => idAlreadyLinkedTickets.includes(v));

                        if (linkedTicketsFromRequesttoLink && linkedTicketsFromRequesttoLink.length !== 0) {
                            setNotification(`Essas solicitações já foram vinculadas: ${linkedTicketsFromRequesttoLink.join(', ')}`, "warning", false);
                        }
                        else if (arrayTickettoLink.includes(parseInt(id))) {
                            setNotification("Não é possivel vincular solicitações com mesmo Nº", "error", true);
                        }
                        else {
                            try {
                                setNotification("Vinculando solicitações", "info", false);

                                const responseVinculo = await solicitationAttendantService.SaveSolicitationLinks(arrayTickettoLink, id);
                                props.setOnVisibleModalVinculo(!props.onVisibleModalVinculo);

                                if (responseVinculo.status === 200) {
                                    setNotification(responseVinculo.data, "success", true);
                                    props.setSelectedRadioRows([]);
                                }
                            }
                            catch (error: any) {
                                let errorResp = JSON.stringify(error.response);
                                let mensagem = "";

                                if (solicitations.length == 1) { mensagem = "A solicitação selecionada já possui outro vínculo"; }
                                else { mensagem = "As solicitações selecionadas já possuem outros vínculos"; }

                                if (!errorResp.includes('Duplicate')) mensagem = "Erro ao salvar os vinculos";

                                props.setOnVisibleModalVinculo(!props.onVisibleModalVinculo);
                                setNotification(mensagem, "error", true);
                            }
                        }
                    }
                }
                else if (arrayTickettoLink.includes(parseInt(id))) {
                    setNotification("Não é possivel vincular solicitações com mesmo Nº", "error", true);
                }
                else {
                    try {
                        setNotification("Vinculando solicitações", "info", false);

                        const responseVinculo = await solicitationAttendantService.SaveSolicitationLinks(arrayTickettoLink, id);
                        props.setOnVisibleModalVinculo(!props.onVisibleModalVinculo);

                        if (responseVinculo.status === 200) {
                            setNotification(responseVinculo.data, "success", true);
                            props.setSelectedRadioRows([]);
                        }
                    }
                    catch (error: any) {
                        let errorResp = JSON.stringify(error.response);
                        let mensagem = "";

                        if (solicitations.length == 1) { mensagem = "A solicitação selecionada já possui outro vínculo"; }
                        else { mensagem = "As solicitações selecionadas já possuem outros vínculos"; }

                        if (!errorResp.includes('Duplicate')) mensagem = "Erro ao salvar os vinculos";

                        props.setOnVisibleModalVinculo(!props.onVisibleModalVinculo);
                        setNotification(mensagem, "error", true);
                    }
                }
            }
            else {
                setNotification("A solicitação informada não é um MAJOR", "warning", true);
            }
        }
        else {
            setNotification("Vinculo pai ou solicitações para vinculos não foram informados", "warning", true);
        }

        setLoadingSaveVinculo(false);
    }

    useEffect(() => {
        if (menu.showHelper) {
            const openVincularPref = pref.dataLocal?.openVincularPref ?? false;
            setVinculoPai((openVincularPref) ? "123457" : "");
        }
    }, [pref.dataLocal?.openVincularPref]);

    return (
        <>
        <AlertNotification open={onNotification} severity={severityMessage} message={messageNotifications} handleClose={() => setOnNotification(false)} />
            {
                props.onVisibleModalVinculo &&
                <div className={"inputVincular"}>
                    <label htmlFor='vincular' className="labelVincular"> Vincular <strong>{props.selectedRadioRows.length}</strong> itens ao chamado: </label>
                    <div className="input-12" style={{ width: "100%", display: 'flex', alignContent: 'center', alignItems: 'center' }}>
                        <PPTextField
                            required
                            placeholder={"Número, assunto ou solicitante"}
                            onChange={(e) => setVinculoPai(e.target.value)}
                            value={vinculoPai}
                            autoComplete={"off"}
                            disabled={loadingSaveVinculo}
                        />
                        <div className="btnActions">
                            <LcLoading loading={loadingSaveVinculo}>
                                <LcIconLink
                                    icon={'ppi ppi-check'}
                                    tooltip="Confirmar"
                                    onClick={() => saveVinculo(vinculoPai, props.rows, props.selectedRadioRows)}
                                    disabled={loadingSaveVinculo}
                                />
                                <LcIconLink
                                    icon={'ppi ppi-x'}
                                    tooltip="Fechar"
                                    onClick={() => {
                                        setVinculoPai('');
                                        props.setOnVisibleModalVinculo(false)
                                    }}
                                    disabled={loadingSaveVinculo}
                                />
                            </LcLoading>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default InputLink;